"use cleint";

import { NewQuestionApiReturn } from "@/@types/exam-question";
import { UpdateQuestionOptionSchemaType } from "@/lib/zod/types";
import api from "@/services/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRef } from "react";

export function useUpdateOption() {
  const queryClient = useQueryClient();
  const abortController = useRef<AbortController | null>(null);

  const mutation = useMutation({
    mutationFn: async (option: UpdateQuestionOptionSchemaType) => {
      abortController.current = new AbortController();

      const { data } = await api.put<NewQuestionApiReturn>(
        "/questions/options",
        option
      );

      return data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["/assessment-by-id"],
      });
    },
  });

  return { ...mutation, abort: () => abortController.current?.abort() };
}
